import { useEffect, useCallback, useState } from "react";
import {
  deleteUserRequest,
  getUserDataRequest,
  getUserRequest,
  restoreUserRequest,
  updateUserDataRequest,
  updateUserRequest,
} from "../../home/network";

export const useGetUser = (id) => {
  const [user, setUser] = useState<any>({});

  const [userLoading, setUserLoading] = useState<boolean>(false);
  const [userDataLoading, setUserDataLoading] = useState<boolean>(false);
  const getUser = useCallback(async () => {
    try {
      setUserLoading(true);
      const res = await getUserRequest(id);
      setUser((prev) => ({ ...prev, ...res.data }));
      setUserLoading(false);
      return res;
    } catch (e) {
      alert(e);
      setUser((prev) => ({
        prev,
      }));
      setUserLoading(false);
    }
  }, []);

  const getUserData = useCallback(async () => {
    try {
      setUserDataLoading(true);
      const res = await getUserDataRequest(id);
      setUser((prev) => ({ ...prev, ...res.data }));
      setUserDataLoading(false);
      return res;
    } catch (e) {
      alert(e);
      setUser((prev) => ({
        prev,
      }));
      setUserDataLoading(false);
    }
  }, []);

  const deleteUser = useCallback(async (id) => {
    const res = await deleteUserRequest(id);
    await getUser();
    return res;
  }, []);

  const restoreUser = useCallback(async (id) => {
    const res = await restoreUserRequest(id);
    await getUser();
    return res;
  }, []);

  const updateUser = useCallback(async (values) => {
    const res = await updateUserRequest(values);
    return res;
  }, []);

  const updateUserData = useCallback(async (values) => {
    const fd = new FormData();
    for (let value in values) {
      if (
        values[value] &&
        [
          "passport_first_page",
          "passport_second_page",
          "driver_license_first_page",
          "driver_license_second_page",
        ].includes(value)
      ) {
        fd.append(value, values[value][0]);
      } else {
        fd.append(value, values[value]);
      }
    }
    const res = await updateUserDataRequest(fd);
    return res;
  }, []);

  useEffect(() => {
    getUser();
    getUserData();
  }, [getUser]);

  return {
    user,
    deleteUser,
    restoreUser,
    userDataLoading,
    userLoading,
    updateUser,
    updateUserData,
  };
};
